import { Link } from 'react-router-dom';
import { useTk } from '@/lib/i18n';

/**
 * Koom GO 首页搜索条。
 *
 * 视觉规格（DESIGN.md §Components > Search Bar (Brand)）：
 *   - 形状：rounded-full pill
 *   - 背景：`brand.primary.50` (#FFFBEB)
 *   - 描边：2px ring `brand.primary.500` (#FFC400)
 *   - 文字：`brand.primary.700` (#A16207) — AA 对比 6.4:1 ✓
 *   - 图标：search 笔触 in `brand.primary.700`
 *
 * 黄色描边 + 浅黄底是「Koom Yellow 是 wayfinding 信号」原则的具象化（PRODUCT.md 设计原则 1）。
 * 不允许在该 pill 内放白色文字（DESIGN.md §1.2 forbidden pairing）。
 *
 * 点击整条进入 `/search` 路由（路由内部承载真实搜索 UI）。
 */
export function YellowSearchBar(): React.ReactElement {
  const tk = useTk();
  return (
    <Link
      to="/search"
      aria-label={tk('home.search.placeholder')}
      className="
        flex items-center gap-2.5
        rounded-full
        bg-brand-primary-50
        ring-2 ring-brand-primary-500
        px-4 py-3
        text-sm font-medium text-brand-primary-700
        transition active:scale-[0.985]
      "
    >
      <SearchGlyph />
      <span className="flex-1 truncate">{tk('home.search.placeholder')}</span>
    </Link>
  );
}

function SearchGlyph(): React.ReactElement {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <circle cx="7" cy="7" r="5" />
      <path d="M11 11l3 3" />
    </svg>
  );
}
